import React from 'react'
// themes
import { colors } from 'themes/index'
// components
import { Input } from 'components/FormElements'
// icons
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/SearchRounded'
import InputAdornment from '@mui/material/InputAdornment'
// views
import { Wrapper, ErrorText } from './views'
// context
import { RiskViewAPIContext } from 'containers/Risks/RiskView/layers/API'
// utils
import { minLength } from 'utils/validators'

const RiskViewSearch: React.FC = () => {
  const { setSearch } = React.useContext(RiskViewAPIContext)

  const [value, setValue] = React.useState('')
  const [error, setError] = React.useState(null)

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    const nextError = minLength(3)(value)

    setValue(value)

    if (value.length && nextError) {
      setError(nextError)
      return
    } else if (error) {
      setError(null)
    }

    setSearch(value)
  }

  const clearInput = () => {
    setValue('')
    setError(null)
    setSearch(null)
  }

  return (
    <Wrapper>
      <SearchIcon fontSize='medium' />
      <Input
        withEllipsis
        value={value}
        disableUnderline
        inputColor={colors.black}
        placeholder={'Search...'}
        onChange={onInputChange}
        endAdornment={
          value ? (
            <InputAdornment position='end' onClick={clearInput} style={{ cursor: 'pointer' }}>
              <CloseIcon fontSize='small' />
            </InputAdornment>
          ) : null
        }
      />
      {error && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  )
}

export default RiskViewSearch
